import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import {Heading, SubHeading, Paragraph,} from "./BlockParts/index";

export default function BlurbBlock({ options, items, idx, settings }) {
  const FontSettings = useSelector((state) => {
    const fontStyle = state.project?.fontStyle || {};
    return {
      heading: fontStyle.heading,
      subHeading: fontStyle.subHeading,
      blurb: fontStyle.blurb,
    };
  }, shallowEqual);
  return (
    <div key={idx} id={"block_" + idx} className="text-[18px] w-full flex flex-col justify-center px-1 overlaytext">
      <Heading options={options} fontStyle={FontSettings?.heading} idx={idx} />
      <SubHeading options={options} fontStyle={FontSettings?.subHeading} idx={idx}/>
      <Paragraph options={options} fontStyle={FontSettings?.blurb} items={items} idx={idx} settings={settings}/>
    </div>
  );
}
